module.exports = __webpack_public_path__ + "img/racecourse-kenilworth-turf-summer-2700.883bfafe.svg";